"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tpa = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const tpa_address_entity_1 = require("./tpa-address.entity");
const tpa_contact_entity_1 = require("./tpa-contact.entity");
const class_transformer_1 = require("class-transformer");
const look_up_entity_1 = require("./look-up.entity");
let Tpa = class Tpa {
    constructor(partial) {
        Object.assign(this, partial);
    }
};
exports.Tpa = Tpa;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Object)
], Tpa.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "name", nullable: false, type: "varchar", length: 200 }),
    tslib_1.__metadata("design:type", String)
], Tpa.prototype, "tpaName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "display_name",
        nullable: false,
        type: "varchar",
        length: 100,
    }),
    tslib_1.__metadata("design:type", String)
], Tpa.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_type_lid", nullable: false, type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Tpa.prototype, "companyTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "website", nullable: true, type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], Tpa.prototype, "website", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", nullable: true, type: "varchar", length: 500 }),
    tslib_1.__metadata("design:type", String)
], Tpa.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", nullable: true, type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Tpa.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], Tpa.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], Tpa.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], Tpa.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Tpa.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Tpa.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => tpa_address_entity_1.TpaAddress, (tpaAddress) => tpaAddress.tpa, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Array)
], Tpa.prototype, "tpaAddresses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => tpa_contact_entity_1.TpaContact, (tpaContact) => tpaContact.tpa),
    tslib_1.__metadata("design:type", Array)
], Tpa.prototype, "contacts", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _e : Object)
], Tpa.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "company_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_f = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _f : Object)
], Tpa.prototype, "companyType", void 0);
exports.Tpa = Tpa = tslib_1.__decorate([
    (0, typeorm_1.Entity)("tpa"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof Partial !== "undefined" && Partial) === "function" ? _a : Object])
], Tpa);
